(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6368,7091],{

/***/ 96368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _hooks_useMobileDetect__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8497);
/* harmony import */ var _csc_dls_Text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45468);
/* harmony import */ var _csc_dls_Icons_CloseIconBold__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7091);
/* harmony import */ var _AccessibilityModal_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(24966);
/* harmony import */ var _AccessibilityModal_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_AccessibilityModal_module_scss__WEBPACK_IMPORTED_MODULE_6__);







var Modal = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(__webpack_require__.e(/* import() */ 8558).then(__webpack_require__.bind(__webpack_require__, 28558)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28558)
            ];
        }
    }
});
var AccessibilityModal = function(param) {
    var open = param.open, onClose = param.onClose;
    var isMobile = (0,_hooks_useMobileDetect__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Modal, {
        open: open,
        onClose: onClose,
        closeable: true,
        closeButton: true,
        closeIcon: _csc_dls_Icons_CloseIconBold__WEBPACK_IMPORTED_MODULE_5__["default"],
        closeIconSize: "sm",
        rounded: true,
        type: isMobile ? "slide" : undefined,
        children: open && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_AccessibilityModal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().mainContent),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_csc_dls_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                    bold: true,
                    size: "xl",
                    children: "Our Commitment to Accessibility"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_csc_dls_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                    className: "mt-4",
                    children: "We are committed to ensuring that our website is open and accessible to the broadest audience possible, including those with visual, hearing, and other disabilities."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_csc_dls_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                    className: "mt-4",
                    children: "We strive to continually improve the user experience for everyone by consulting relevant accessibility standards."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_csc_dls_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                    className: "mt-4",
                    children: [
                        "If you have questions, comments, or encounter any difficulty relating to the accessibility of our website, please contact the One Kings Lane Accessibility Team at",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "mailto:accessibility@onekingslane.com",
                            children: "accessibility@onekingslane.com."
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (AccessibilityModal);


/***/ }),

/***/ 8497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var MOBILE_SCREEN_WIDTH = 768;
var useMobileDetect = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(MOBILE_SCREEN_WIDTH), windowWidth = ref[0], setWindowWidth = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setWindowWidth(window.innerWidth);
        var windowWidthEventListener = function() {
            setWindowWidth(window === null || window === void 0 ? void 0 : window.innerWidth);
        };
        window === null || window === void 0 ? void 0 : window.addEventListener("resize", windowWidthEventListener);
        return function() {
            window === null || window === void 0 ? void 0 : window.removeEventListener("resize", windowWidthEventListener);
        };
    }, [
        windowWidth
    ]);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true), isMobile = ref1[0], setIsMobile = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (windowWidth < MOBILE_SCREEN_WIDTH) {
            setIsMobile(true);
        } else {
            setIsMobile(false);
        }
    }, [
        windowWidth
    ]);
    return isMobile;
};
/* harmony default export */ __webpack_exports__["Z"] = (useMobileDetect);


/***/ }),

/***/ 7091:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var React = __webpack_require__(67294);
function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function(k) {
            if (k !== "default") {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function get() {
                        return e[k];
                    }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}
var React__namespace = /*#__PURE__*/ _interopNamespace(React);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var SvgCloseIconBold = function SvgCloseIconBold(props) {
    return /*#__PURE__*/ React__namespace.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: "10",
        height: "11",
        viewBox: "0 0 10 11",
        fill: "none"
    }, props), /*#__PURE__*/ React__namespace.createElement("line", {
        x1: "0.5",
        y1: "-0.5",
        x2: "13.2549",
        y2: "-0.5",
        transform: "matrix(0.686624 0.727013 -0.686624 0.727013 0 1)",
        stroke: "#323232",
        strokeLinecap: "round"
    }), /*#__PURE__*/ React__namespace.createElement("line", {
        x1: "0.5",
        y1: "-0.5",
        x2: "13.2549",
        y2: "-0.5",
        transform: "matrix(-0.686624 0.727013 0.686624 0.727013 10 1)",
        stroke: "#323232",
        strokeLinecap: "round"
    }));
};
exports.SvgCloseIconBold = SvgCloseIconBold;
exports["default"] = SvgCloseIconBold; //# sourceMappingURL=CloseIconBold.js.map


/***/ }),

/***/ 24966:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"AccessibilityModal_mainContent__liFMY"};

/***/ })

}]);